<template>
  <v-col
    cols="auto"
    v-if="itemsNumber != null"
  >
    <span class="d-flex justify-center align-center">
      <v-img
        :src="icon"
        :max-width="maxWidth"
        class="mr-2"
      />
      {{ itemsNumber }} {{ itemsNumber | pluralize(singularLabel, pluralLabel) }}
    </span>
  </v-col>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ItemsNumberCol extends Vue {
  @Prop() itemsNumber?: number
  @Prop() icon: string
  @Prop({ required: true }) singularLabel: string
  @Prop() pluralLabel: string
  @Prop({ default: 20 }) maxWidth: number

}
</script>
